import styles from './DirectionsPanel.module.scss';
import React, { useState } from 'react';
import { getCurrentPosition } from '../../lib/util';
import axios from 'axios';
import * as Console from 'console';

const DirectionsPanel = (props: any) => {
  const closePanel = () => props.setShowDirectionsPanel(false);
  const setValidationMessage = (message: string) => props.setValidationMessage(message);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');

  const formattedAddress = `${address1} ${address2 ? address2 + ' ' : ''}${city} ${state} ${zip}`.split(' ').join('+');

  return (
    <div className="custom-container-internal">
      <hr />
      <h4>Get Directions {showAddressForm ? 'To "' + props.toAddress + '" From:' : ''}</h4>
      {!showAddressForm ? (
        <div>
          <p>How would you like to get directions?</p>
          {/* <button
            className={styles.profileButton}
            onClick={() => {
              (async () => await getCurrentPosition())();
              // getDirections();
              closePanel();
            }}
          >
            Device Location
          </button> */}
          <button className={styles.profileButton} onClick={() => setShowAddressForm(!showAddressForm)}>
            Enter Location Manually
          </button>
          <a href={`https://www.google.com/maps/place/${props.formattedAddress}`} target="_blank" onClick={() => closePanel()}>
            <button className={styles.profileButton}>Get Directions on Google Maps</button>
          </a>
        </div>
      ) : null}
      {showAddressForm ? (
        <div className={styles.fieldContainer}>
          <div>
            <input type="text" placeholder={'Street Address 1'} className={styles.address} onChange={(e) => setAddress1(e.target.value)} />
          </div>
          <div>
            <input type="text" placeholder={'Street Address 2'} className={styles.address} onChange={(e) => setAddress2(e.target.value)} />
          </div>
          <div>
            <input type="text" placeholder={'City'} className={styles.city} onChange={(e) => setCity(e.target.value)} />
            <input type="text" placeholder={'State'} className={styles.state} onChange={(e) => setState(e.target.value)} />
            <input type="text" placeholder={'Zip Code'} className={styles.zip} onChange={(e) => setZip(e.target.value)} />
          </div>
          <button
            className={styles.profileButton}
            onClick={() =>
              validateAddress(address1, city, state, zip, setValidationMessage, () =>
                handleDirections(closePanel, props.getDirections, formattedAddress, props.formattedToAddress, props.setDirections, props.setMiles, props.getDistance)
              )
            }
          >
            Show Directions From Address
          </button>
        </div>
      ) : null}
    </div>
  );
};

const handleDirections = (
  closePanel: () => void,
  getDirections: (start: any, end: any, setDirections: any) => void,
  formattedFromAddress: string,
  formattedToAddress: string,
  setDirections: () => void,
  setMiles: any,
  getDistance: any
) => {
  // Convert formatted Addresses into
  (async () => {
    const geocodeFrom = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedFromAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
    const geocodeTo = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedToAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
    const start: { lat: number; lng: number } = geocodeFrom.data.results[0].geometry.location;
    const end: { lat: number; lng: number } = geocodeTo.data.results[0].geometry.location;
    getDirections(start, end, setDirections);
    setMiles(getDistance(start, end));
  })();
  closePanel();
};

const validateAddress = (address1: string, city: string, state: string, zip: string, setValidationMessage: any, callback: any) => {
  if (!address1?.trim().length) {
    setValidationMessage('Street Address 1 is required. Please enter a street address and try again.');
  } else if (!city?.trim().length) {
    setValidationMessage('City is required. Please enter a city and try again.');
  } else if (!state?.trim().length) {
    setValidationMessage('State is required. Please enter a state and try again.');
  } else if (!zip?.trim().length) {
    setValidationMessage('Zip Code is required. Please enter a zip code and try again.');
  } else {
    setValidationMessage('');
    callback();
  }
};

export default DirectionsPanel;
